// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"c8447d4d","277":"024af19c","721":"0a2e6221","835":"ae77be9f","850":"0a2e6221","891":"4a970f0a"}[chunkId] + ".chunk.css";
};